import { render, staticRenderFns } from "./NewPatients.vue?vue&type=template&id=535801e2&"
import script from "./NewPatients.vue?vue&type=script&lang=js&"
export * from "./NewPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports